import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // make sure submit button is active on page load
    this.enableSubmitButton();
  }

  submit(event) {
    // only block if invalid
    if (this.invalidCustomerInputs() > 0) {
      event.preventDefault();
      this.scrollToTop();
      const invalid = this.element.querySelector(".is-invalid");
      if (invalid) invalid.focus();
    }
    // if everything ok - let browser submit form naturally
  }

  enableSubmitButton() {
    const submit = this.element.querySelector("button[type=\"submit\"], input[type=\"submit\"], [name=\"commit\"]");
    if (submit) submit.removeAttribute("disabled");
  }

  invalidCustomerInputs() {
    const invalidCustomerInputs = [];
    const walletAddress = this.element.querySelector("#customer_wallet_addresses");
    if (!walletAddress) return 0;

    const addresses = walletAddress.value.split(",").map(a => a.trim());

    addresses.forEach(item => {
      if (item !== "" && !/^0x[a-fA-F0-9]{40}$/.test(item)) {
        invalidCustomerInputs.push(item);
      }
    });

    if (invalidCustomerInputs.length > 0) {
      walletAddress.classList.add("is-invalid");
    } else {
      walletAddress.classList.remove("is-invalid");
    }

    return invalidCustomerInputs.length;
  }

  scrollToTop() {
    const container = document.querySelector(".wrapper.full") || document.documentElement;
    container.scrollTop = 0;
  }
}
